/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
import EventEmitter from 'events';

// "inherit" EventEmitter - MUST be done before any other imports that use prestashop events
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

/* eslint-disable */
import 'expose-loader?exposes=Tether!tether';
import 'bootstrap';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import 'tooltipster';
import './selectors';

import './modules/responsive';
import './custom';

import DropDown from './components/drop-down';
import usePasswordPolicy from './components/usePasswordPolicy';
import TopMenu from './components/top-menu';

import './components/block-cart';
/* eslint-enable */

$(document).ready(() => {
  const dropDown = new DropDown($('.js-dropdown'));
  const topMenu = new TopMenu($('.js-top-menu ul[data-depth="0"]'));
  dropDown.init();
  topMenu.init();
  usePasswordPolicy('.field-password-policy');

  // Lazy load form component if necessary
  if (document.querySelector('.js-child-focus, button[data-action="show-password"]')) {
    import('./components/form').then((module) => {
      // eslint-disable-next-line new-cap
      (new module.default()).init();
    });
  }

  // Lazy load product miniature if necessary
  if (document.querySelector('.js-product-miniature')) {
    import('./components/product-miniature').then((module) => {
      // eslint-disable-next-line new-cap
      (new module.default()).init();
    });
  }

  // Lazy load product select
  import('./components/product-select').then((module) => {
    // eslint-disable-next-line new-cap
    (new module.default()).init();
  });

  // Lazy load customer
  import('./modules/customer').then((module) => {
    module.default();
  });

  // Lazy load cart
  import('./modules/cart').then((module) => {
    module.default();
  });

  // Lazy load listing
  import('./modules/listing').then((module) => {
    module.default();
  });

  // Lazy load product
  import('./modules/product').then((module) => {
    module.default();
  });

  $('.carousel[data-touch="true"]').swipe({
    swipe(event, direction) {
      if (direction === 'left') {
        $(this).carousel('next');
      }
      if (direction === 'right') {
        $(this).carousel('prev');
      }
    },
    allowPageScroll: 'vertical',
  });

  document.addEventListener('scroll', () => {
    if (document.documentElement.scrollTop > 400) {
      $('.back-to-top').addClass('active');
    } else {
      $('.back-to-top').removeClass('active');
    }
  }, {passive: true, capture: true} /* Capture event */);

  $('.tooltipactive').tooltip({
    classes: {
      'ui-tooltip': 'highlight',
    },
  });

  // hide newsletter form when on unsubscribe page
  if (window.location.href.indexOf('newsletter-odhlaseni') > -1) {
    $('.block_newsletter_webit').hide();
  }
});
